const initialState = {
  customer: {},
};

export default initialState;
